<template>
  <div>
    <div class="positionBntExportPlaning">
      <export-excel v-if="indexTab === 'annee'" :dataExport="dataExportPlanningAnnuel"/>
    </div>
    <div class="positionBntExportPlaning mt-8">
      <label  v-if="indexTab === 'semaine'">
        <input type="checkbox"
               id="checkbox"
               :value='showAnnonceur'
               v-model="showAnnonceur"> Afficher les annonceurs
      </label>
    </div>
    <b-tabs v-model="indexTab" type="is-toggle">
      <b-tab-item value="semaine" label="Semaine">
        <div class="columns">
          <div class="column is-one-quarter">
            <div class="buttons">
            <b-button
              type="is-success" class="has-text-link"
              :class="getPoseOption === typesOptions.SELECTION ? 'pose_option' : 'no_pose_option'"
              @click="setPoseOption(typesOptions.SELECTION)">
              Sélection
            </b-button>
            <b-button
              type="is-bloque" class="has-text-link"
              :class="getPoseOption === typesOptions.BLOQUE ? 'pose_option' : 'no_pose_option'"
              @click="setPoseOption(typesOptions.BLOQUE)">
              Bloquer
            </b-button>
            <b-button
              type="is-option-planning" class="has-text-link"
              :class="getPoseOption === typesOptions.OPTION ? 'pose_option' : 'no_pose_option'"
              @click="setPoseOption(typesOptions.OPTION)">
              Option
            </b-button>
            </div>
          </div>
          <div class="column is-half has-text-centered">
            <div>
              <button class="button" @click="updateDateDebut(-criterePlanning.weeks)">
                <b-icon icon="chevron-double-left"></b-icon>
              </button>
              <button class="button" @click="updateDateDebut(-1)">
                <b-icon icon="chevron-left"></b-icon>
              </button>
              <span style="min-width: 290px;display: inline-block;">
                {{ dateDebutFormattee }} - {{ dateFinFormattee }}
              </span>
              <button class="button" @click="updateDateDebut(1)">
                <b-icon icon="chevron-right"></b-icon>
              </button>
              <button class="button" @click="updateDateDebut(criterePlanning.weeks)">
                <b-icon icon="chevron-double-right"></b-icon>
              </button>
            </div>
          </div>
          <div class="column">
            <div class="is-pulled-right">
              <a class="button" @click="getPlaningPdf()">
                <b-icon icon="printer" ></b-icon>
                <span class="ellipsis btn_consultation">Imprimer</span>
              </a>
            </div>
          </div>
          <div class="column">
            <div class="is-pulled-right">
              <a class="button" @click="activeModeConsultation()"
                v-bind:class="{'is-primary is-outlined has-background-white has-text-primary'
              :criterePlanning.modeConsultation}">
                <b-icon icon="eye-outline" ></b-icon>
                <span class="ellipsis btn_consultation">Consultation</span>
              </a>
            </div>
          </div>
        </div>
        <v-client-table class="fixed_header" ref="planningTempo"
                          :data="reseauxWithFilter"
                          :columns="columns"
                          :options="options"
                          @pagination="onPageChanged"
                          @sorted="onPageChanged">
          <div slot="nbFaces" slot-scope="props">
            <div class="is-pulled-right">{{props.row.nbFaces}}</div>
          </div>
          <div slot="depCode" slot-scope="props">
            <div class="is-pulled-right">{{props.row.depCode}}</div>
          </div>
          <div slot="selected" slot-scope="props">
            <input class="checkbox-disabled" type="checkbox" disabled :checked="props.row.selected">
          </div>
          <div slot="zoom" slot-scope="props" style="text-align:center">
            <b-button
              class="has-background-transparent no_border pa-0"
              @click="zoomReseau(props.row)"
              :disabled="!isValidLatLng(props.row.latitude, props.row.longitude)">
              <b-icon icon="google-maps" type="is-primary"/>
            </b-button>
          </div>
          <div slot="diaporama" slot-scope="props" style="text-align:center">
            <a @click="ouvrirDiaporama(props.row)">
              <b-icon icon="image-multiple" type="is-primary"></b-icon>
            </a>
          </div>
        </v-client-table>
        <b-modal
          v-model="isComponentOuvrirListeFaces"
          has-modal-card
          class="modal modal-liste-faces"
          width="80vw">
          <Consultation
            :reseau="reseau"
            :disabled="disabled"
            :no-update="true"
            :index-tabs="1"/>
        </b-modal>
      </b-tab-item>
      <b-tab-item value="annee" label="Année">
        <vue-global-planning
          v-if="indexTab === 'annee'"
          @dataExport="dataExportPlanningAnnuel = $event"/>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { getPlaningReseauxPdf } from '@/api/reseaux/index';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import gestionErreur from '@/services/general/gestionErreur';
import { isDispo } from '@/services/decorateur/decorateurRectangleReseauxTempo';
import * as typesOptions from '@/configuration/optionConf';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import Consultation from '@/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo/consultation';
import getAnneeSemaine from '@/services/general/getAnneeSemaine';
import getReseauAvecFaces from '@/services/reseauxTempo/getReseauAvecFaces';
import PlanningTempoSvg from './planningTempoSvg';
import VueGlobalPlanning from './vueGlobalPanning';
import ExportExcel from './exportExcel';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');
const Modal = createNamespacedHelpers('modal');
const Panier = createNamespacedHelpers('panier');
const User = createNamespacedHelpers('user');

export default {
  name: 'planning',
  components: {
    VueGlobalPlanning,
    ExportExcel,
    Consultation,
  },
  data() {
    return {
      dureeAffichage: [
        { dureeEnSemaines: 5, label: '5 semaines' },
      ],
      trad: {
        code: '↑↓ Code',
        libelle: '↑↓ Libelle',
        depCode: '↑↓ Dep',
        ville: '↑↓ Ville',
        format: '↑↓ Format',
        Planning: 'Planning',
        selected: '',
        zoom: 'Carto',
        diaporama: 'Diapo',
      },
      isComponentOuvrirListeFaces: false,
      disabled: true,
      reseau: null,
      current: 0,
      isSelect: false,
      semaineClick: [],
      indexTab: 'semaine',
      dataExportPlanningAnnuel: {},
      typesOptions,
    };
  },
  computed: {
    ...VenteReseauxTempo.mapGetters({
      reseauxWithFilter: 'reseauxWithFilter',
      getCriterePlanning: 'criterePlanning',
      markersReseaux: 'markersReseaux',
      getActiveTabReseau: 'activeTabReseau',
      getZoomMarker: 'zoomMarker',
      dataPropositions: 'dataPropositions',
      getDateVisualisation: 'dateDeVisualisation',
      getPoseOption: 'poseOption',
    }),
    ...Panier.mapGetters({
      reseauxTempoPanier: 'reseauxTempoPanier',
    }),
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesReseauSelect: 'facesSelectDiapo',
    }),
    ...User.mapGetters({
      getUserId: 'userEmail',
      site: 'site',
    }),
    criterePlanning: {
      get() {
        return this.getCriterePlanning;
      },
      set(value) {
        this.setCriterePlanning(value);
      },
    },
    showAnnonceur: {
      get() {
        return this.criterePlanning.showAnnonceur;
      },
      set(value) {
        this.reloadData({
          debut: this.criterePlanning.dateStart,
          nombreSemaines: this.criterePlanning.weeks,
          showAnnonceur: value,
        });
      },
    },
    activeTab: {
      get() {
        return this.getActiveTabReseau;
      },
      set(value) {
        this.setActiveTabReseau(value);
      },
    },
    facesReseauSelectDiapo: {
      get() {
        return this.getFacesReseauSelect;
      },
      set(value) {
        this.setFacesReseauSelect(value);
      },
    },
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
    zoomMarker: {
      get() {
        return this.getZoomMarker;
      },
      set(value) {
        this.setZoomMarker(value);
      },
    },
    dateDebutFormattee() {
      return this.criterePlanning.dateStart.format('LL');
    },
    dateFinFormattee() {
      return this.criterePlanning.dateEnd.format('LL');
    },
    columns() {
      return ['selected', 'code', 'libelle', 'depCode', 'ville', 'format', 'zoom', 'diaporama', 'planning'];
    },
    options() {
      const that = this;
      return {
        headings: {
          zoom: this.trad.zoom,
          code: this.trad.code,
          selected: this.trad.selected,
          libelle: this.trad.libelle,
          depCode: this.trad.depCode,
          ville: this.trad.ville,
          format: this.trad.format,
          diaporama: this.trad.diaporama,
          planning(h) {
            return that.getPlanningHeader(h);
          },
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        perPage: this.criterePlanning.maxReseaux,
        texts: TEXTS,
        templates: {
          planning: PlanningTempoSvg,
        },
        columnsClasses: {
          selected: 'ventesReseauTempoPlanningTailleColonneCheckbox',
          libelle: 'ellipsis ventesReseauTempoPlanningTailleColonneLibelle',
          depCode: 'ellipsis ventesReseauTempoPlanningTailleColonneCode',
          ville: 'ellipsis ventesReseauTempoPlanningTailleColonneVille',
          code: 'ellipsis ventesReseauTempoPlanningTailleColonneVille',
          format: 'ellipsis ventesReseauTempoPlanningTailleColonneFormat',
          planning: 'ventesReseauTempoPlanningTailleColonnePlanning',
          zoom: 'ventesReseauTempoPlanningTailleColonneIcone',
          diaporama: 'ventesReseauTempoPlanningTailleColonneIcone',
        },
      };
    },
  },
  mounted() {
    // window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...VenteReseauxTempo.mapActions({
      actionsChangementDateDebutPlanningTempo: 'changementDateDebutPlanningTempo',
      actionsGestionPanier: 'gestionPanier',
    }),
    ...VenteReseauxTempo.mapMutations({
      setCriterePlanning: types.SET_CRITERE_PLANNING_TEMPO,
      setActiveTabReseau: types.SET_ACTIVE_TAB_RESEAU,
      setZoomMarker: types.SET_ZOOM_MARKER,
      setReseauxSelected: types.SET_RESEAUX_SELECTED,
      setPoseOption: types.SET_POSE_OPTION,
    }),
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
      setFacesReseauSelect: typesModal.SET_FACES_SELECT_DIAPO,
    }),
    ...Panier.mapMutations({
      setResetPanier: typesPanier.RESET_PANIER,
    }),
    onPageChanged() {
      this.reloadData(
        {
          debut: this.criterePlanning.dateStart,
          nombreSemaines: this.criterePlanning.weeks,
        },
      );
    },
    async handleResize() {
      await this.actionsChangementDateDebutPlanningTempo(
        {
          debut: this.criterePlanning.dateStart,
          nombreSemaines: this.criterePlanning.weeks,
        },
      );
    },
    async reloadData(payload) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      payload.resNums = this.$refs.planningTempo.filteredData.map((el) => el.num);
      try {
        await this.actionsChangementDateDebutPlanningTempo(payload);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        gestionErreur('Erreur lors du chargement du planning', e);
      }
    },
    updateDureeEnSemaines(duree) {
      if (duree === this.criterePlanning.weeks) {
        return;
      }
      this.loadingComponent = this.$buefy.loading.open({ container: null });
      this.reloadData(
        {
          debut: this.criterePlanning.dateStart,
          nombreSemaines: duree,
        },
      );
    },
    updateDateDebut(decalage) {
      this.reloadData(
        {
          debut: this.criterePlanning.dateStart.clone().add(decalage * 7, 'days'),
          nombreSemaines: this.criterePlanning.weeks,
        },
      );
    },
    getPlanningHeader(h) {
      return h('svg', {
        attrs: {
          width: '100%',
          height: '32px',
        },
      },
      this.getPlanningHeaderSemaine(h),
      );
    },
    getPlanningHeaderSemaine(h) {
      const lineAndTextArray = [];
      const nombreJoursTotal = this.criterePlanning.weeks * 7;
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateEnd;
      let dateVar = dateStart.clone();
      while (dateVar < dateEnd) {
        const offset = dateVar.diff(dateStart, 'days') / nombreJoursTotal * 100;
        if (!dateVar.isSame(dateStart)) {
          lineAndTextArray.push(h('line', {
            attrs: {
              x1: offset + '%',
              y1: '0',
              x2: offset + '%',
              y2: '80%',
              style: 'stroke: #E3E1F2;stroke-width: 2px',
            },
          }));
        }
        lineAndTextArray.push(h('text', {
          attrs: {
            x: (offset + 0.5) + '%',
            y: '25%',
            'dominant-baseline': 'central',
            'text-anchor': 'start',
            'font-size': '14px',
            fill: '#5E738B',
          },
        }, 'S' + dateVar.format('WW')));
        lineAndTextArray.push(h('text', {
          attrs: {
            x: (offset + 0.5) + '%',
            y: '75%',
            'dominant-baseline': 'central',
            'text-anchor': 'start',
            'font-size': '11px',
            fill: '#5E738B',
          },
        }, dateVar.format('L')));
        if (this.reseauxWithFilter.map(el => el.selected).includes(true) &&
          this.semaineClick.includes(dateVar.isoWeek())) {
          lineAndTextArray.push(h('rect', {
            attrs: {
              x: (offset + 11.4) + '%',
              y: '2.3',
              height: '15',
              width: '15',
              stroke: 'transparent',
              fill: '#49db70',
              style: 'cursor: pointer',
            },
          }));
        }
        lineAndTextArray.push(h('rect', {
          attrs: {
            x: (offset + 11) + '%',
            y: '0',
            height: '20',
            width: '20',
            stroke: '#5E738B',
            fill: 'transparent',
            style: 'cursor: pointer',
            id: dateVar.format('L'),
          },
          on: {
            click: (e) => {
              const date = moment(e.target.attributes.id.value, 'L');
              if (this.semaineClick.includes(date.isoWeek())) {
                const index = this.semaineClick.indexOf(date.isoWeek());
                this.semaineClick.splice(index, 1);
              } else {
                this.semaineClick.push(date.isoWeek());
              }
              this.selectAll({
                annee: date.isoWeekYear(),
                semaine: date.isoWeek(),
                checked: true,
              });
              e.stopPropagation();
            },
          },
        }));
        dateVar = dateVar.add(7, 'days');
      }
      return lineAndTextArray;
    },
    async getPlaningPdf() {
      const annee = moment(this.getDateVisualisation).format('GGGG');
      const derniereSemaine = moment(`${annee}-12-28`, 'YYYY-MM-DD').isoWeek();
      const dateStart = moment(`${annee}-01`, 'GGGG-WW').format('YYYYMMDD');
      const dateEnd = moment(`${annee}-${derniereSemaine}`, 'GGGG-WW').format('YYYYMMDD');
      let resNums = this.$refs.planningTempo.filteredData.map((el) => el.num);
      if (this.site === 'alfa') {
        resNums = this.$refs.planningTempo.filteredData
          .sort((a, b) => a.code.localeCompare(b.code))
          .map((el) => el.num);
      }
      const infosReseaux = this.$refs.planningTempo.filteredData
        .map((el) => ({
          libelle: el.libelle,
          num: el.num }));
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const response = await getPlaningReseauxPdf(dateStart, dateEnd, resNums, infosReseaux,
          this.getUserId);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.setResetPanier();
        this.reseauxWithFilter
          .filter(reseau => reseau.selected)
          .forEach(reseau => {
            this.setReseauxSelected({
              data: reseau.num,
              value: false,
            });
          });
        loadingComponent.close();
        return true;
      } catch (error) {
        loadingComponent.close();
        return false;
      }
    },
    async zoomReseau(reseau) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        this.reseau = await getReseauAvecFaces(reseau, this.getDateVisualisation);
        this.isComponentOuvrirListeFaces = true;
      } catch (e) {
        gestionErreur(`Erreur lors de la récupération des faces du réseau tempo n°${reseau.num}`, e);
      } finally {
        loadingComponent.close();
      }
    },
    ouvrirDiaporama(reseau) {
      reseau.listeFaces.forEach((el) => {
        el.libelleReseau = reseau.libelle;
      });
      this.facesReseauSelectDiapo = reseau.listeFaces;
      this.isComponentDiaporama = true;
    },
    activeModeConsultation() {
      this.criterePlanning.modeConsultation = !this.criterePlanning.modeConsultation;
    },
    async selectAll(info) {
      const key = getAnneeSemaine(info.annee, info.semaine);
      this.reseauxWithFilter.forEach(async (el) => {
        if (this.dataPropositions[el.num]) {
          const casePlanning = this.dataPropositions[el.num][key];
          if (isDispo(casePlanning)) {
            await this.clickCase(info, el.num);
          }
        }
      });
    },
    async clickCase(info, num) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const key = getAnneeSemaine(info.annee, info.semaine);
      this.$set(this.dataPropositions[num][key], 'checked', !this.isSelect);
      await this.actionsGestionPanier({
        resNum: num,
        semaine: info.semaine,
        annee: info.annee,
        dataPropositions: this.dataPropositions[num][key],
      });

      const reseauPanier = this.reseauxTempoPanier.find((el) => {
        return el.num === num;
      });
      this.setReseauxSelected({
        data: num,
        value: reseauPanier !== undefined && reseauPanier !== null,
      });
      loadingComponent.close();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/recherche/planning.vue